import { CANONICAL_PUBLIC_HOST } from '@/lib/legal-documents';
import { getVersionedPublicAssetUrl } from '@/lib/staticAssetUrls';

export const HOMEPAGE_URL = 'https://www.s-shot.ru/';
export const HOMEPAGE_OG_IMAGE = getVersionedPublicAssetUrl('s-shot-mark.png', CANONICAL_PUBLIC_HOST);

export const homepageMetadata = {
  title: 'S-SHOT | Извлечение данных с сайтов и структурированные веб-данные',
  description:
    'Запускайте извлечение, проверяйте страницу по скриншоту и получайте структурированные веб-данные для шаблонов, датасетов и API.',
  canonical: HOMEPAGE_URL,
  ogImage: HOMEPAGE_OG_IMAGE,
  siteName: 'S-SHOT',
} as const;

export const homepageHeroCopy = {
  eyebrow: 'Извлечение данных',
  title: 'Сайт на входе.\nДанные на выходе.',
  description:
    'Запустите извлечение, проверьте страницу по скриншоту и получите поля, готовые для шаблонов, датасетов и API.',
  benefits: ['Публичные данные', 'Проверка по скриншоту', 'Шаблоны и API'],
} as const;

export const homepageHowItWorksCopy = {
  eyebrow: 'Как это работает',
  title: 'От страницы к структурированным данным за три шага.',
  description:
    'Главная задача первого экрана: быстро запустить извлечение, увидеть проверочный скриншот и получить поля без ручной разметки.',
} as const;

export const homepageUseCasesCopy = {
  eyebrow: 'Сценарии',
  title: 'Шаблоны для парсинга маркетплейсов, объявлений и каталогов.',
  description:
    'Используйте готовые сценарии для сбора цен, карточек товаров, объявлений и объектов недвижимости. Настраивайте параметры и получайте структурированные данные.',
} as const;

export const homepageUseCaseFlows = [
  {
    title: 'Парсинг карточек товаров',
    badge: 'Каталог',
    description:
      'Собирайте цены, наличие, рейтинги и данные продавца с маркетплейсов Wildberries, Ozon и Яндекс Маркета.',
    stats: ['Есть превью', 'Готово к схеме', 'Популярный'],
    fields: ['title', 'price', 'rating', 'variants'],
  },
  {
    title: 'Поиск бизнес-контактов',
    badge: 'Лидогенерация',
    description:
      'Собирайте публичные адреса электронной почты, телефоны, сайты и социальные ссылки со страниц компаний и каталогов.',
    stats: ['Подходит для лидов', 'Быстрый старт', '2-шаговое обогащение'],
    fields: ['company', 'email', 'phone', 'linkedin'],
  },
  {
    title: 'Сбор карточек на картах',
    badge: 'Локальный поиск',
    description:
      'Создавайте списки по локациям с рейтингами, часами работы, категориями, числом отзывов и тегами услуг.',
    stats: ['Geo-фильтры', 'Сниппеты отзывов', 'Данные ранжирования'],
    fields: ['name', 'address', 'rating', 'hours'],
  },
] as const;

export const homepageFaqCopy = {
  eyebrow: 'FAQ',
  title: 'Что важно знать перед первым запуском.',
  description:
    'S-SHOT помогает извлекать данные с сайтов, проверять источник по скриншоту и собирать структурированные веб-данные для шаблонов, датасетов и API.',
} as const;

export const homepageFaqItems = [
  {
    question: 'Какие данные можно извлекать с сайтов?',
    answer:
      'Карточки товаров, каталоги, контактные страницы, выдачу, списки компаний и другие публичные страницы, где нужны структурированные поля и повторные запуски.',
  },
  {
    question: 'Как проверить, что результат собран корректно?',
    answer:
      'Запуск может сохранять скриншот страницы. Источник, проверочный снимок и структурированные поля остаются в одном интерфейсе без переключения между экранами.',
  },
  {
    question: 'Когда нужны шаблоны?',
    answer:
      'Шаблоны нужны для повторяющихся задач: один раз задаете структуру полей, а затем используете ее для новых страниц, партий запусков и повторного мониторинга.',
  },
  {
    question: 'Куда можно передавать результат?',
    answer:
      'Структурированные веб-данные можно использовать в шаблонах, датасетах, внутренних процессах и API-сценариях, когда результат нужен в понятном машинном виде.',
  },
  {
    question: 'Подходит ли платформа для мониторинга цен и каталогов?',
    answer:
      'Да. S-SHOT подходит для мониторинга цен на Wildberries, Ozon, Яндекс Маркете, отслеживания объявлений на Авито и аналитики недвижимости на Циан и Домклик.',
  },
] as const;

export const homepageFeatureList = [
  'Извлечение данных с сайтов',
  'Скриншот для проверки результата',
  'Шаблоны для повторных запусков',
  'Структурированные веб-данные для API',
] as const;
